/* Fixed shared deadline, recomputed from the clock, never reset per visitor. */
(() => {
  const tagName = 'indi-braquage-countdown';
  if (customElements.get(tagName)) return;

  class BraquageCountdown extends HTMLElement {
    connectedCallback() {
      clearInterval(this.intervalId);
      this.deadline = Date.parse(this.dataset.deadline || '');
      this.onVisibilityChange = () => {
        if (!document.hidden) this.update();
      };
      // Also works when variant changes or the theme editor insert fresh HTML.
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.label = this.querySelector('[data-countdown-label]');
        this.value = this.querySelector('[data-countdown-value]');
        if (!this.label || !this.value || !Number.isFinite(this.deadline)) return;
        if (this.update()) this.intervalId = setInterval(() => this.update(), 1000);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
      });
    }

    update() {
      if (!this.isConnected || !this.label || !this.value) return false;
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (remaining === 0) {
        this.label.textContent = 'Vente terminée';
        this.value.hidden = true;
        clearInterval(this.intervalId);
        return false;
      }
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      const pad = (number) => String(number).padStart(2, '0');
      this.label.textContent = 'Fin de la vente dans';
      this.value.hidden = false;
      this.value.textContent = `${pad(hours)} h ${pad(minutes)} min ${pad(seconds)} s`;
      return true;
    }

    disconnectedCallback() {
      clearInterval(this.intervalId);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
  }

  customElements.define(tagName, BraquageCountdown);
})();
